import { api } from '../../App'

const BASE = 'https://api.menu-rest.com/api/v1'

export const getMenu = restId => {
  return api.get(`${BASE}/restaurant/${restId}/menu`)
}

export const getBusinessMenu = (restId, date) => {
  return api.get(`${BASE}/restaurant/${restId}/businessmenu/${date}`)
}

// hidden=1 — вернуть и скрытые блюда (status: 0) вместе с видимыми (status: 1),
// нужно для модалки «+», чтобы можно было вернуть скрытое блюдо в меню.
export const getAllMenu = restId => {
  return api.get(`${BASE}/admin/${restId}/menu?hidden=1`)
}

export const setStoplist = (restId, menuId, data) => {
  return api.put(`${BASE}/admin/${restId}/stoplist/${menuId}`, data)
}

export const setQuantity = (restId, menuId, data) => {
  return api.put(`${BASE}/admin/${restId}/stoplist/${menuId}/quantity`, data)
}

export const addDishToBusinessLunch = (restId, blId, data) => {
  return api.post(`${BASE}/admin/${restId}/blmenu/${blId}`, data)
}

export const addDishToSection = (restId, menuId, data) => {
  return api.put(`${BASE}/admin/${restId}/menu/${menuId}`, data)
}

// Обратимо скрыть / вернуть блюдо в обычной секции меню.
// available строго boolean; в ответе data.status: 0 — скрыто, 1 — в меню.
// data: null при 200 — блюда с таким id в ресторане нет (нужен refetch меню).
export const setMenuAvailable = (restId, menuId, available) => {
  return api.put(`${BASE}/admin/${restId}/menu/${menuId}/available`, { available })
}

// Убрать блюдо из категории бизнес-ланча (зеркально POST .../blmenu/{blId}).
// Без body. Удаляется только связь «блюдо — ланч», само блюдо остаётся в меню.
export const removeDishFromBusinessLunch = (restId, blId, menuId) => {
  return api.delete(`${BASE}/admin/${restId}/blmenu/${blId}/${menuId}`)
}
